export default __webpack_public_path__ + "images/GO.27b6cba.png";